import { ImageHtml } from '@fmpedia/html-tools'

export { ImageHtml }
